<template>
  <div class="container py-5">
    <div class="columns">

      <div class="column is-9 buttons">
        <a class="button is-primary" @click="createNewCutSheet()">
          Add Cut Sheet
        </a>
        <a class="button"
          v-if="selected.length > 0"
          @click="launchConfirmDelete(true)">
          <span class="icon is-medium">
            <i class="fas fa-trash has-text-danger"></i>
          </span>
          <span>Delete {{ selected.length }} Selected Cut Sheets</span>
        </a>
      </div>

      <div class="column is-3">
        <search-autocomplete
          :value="filters.project_id"
          placeholder="Filter cut sheets by project"
          @input="setFilter({ field: 'project_id', value: $event })"/>
      </div>

      <!-- <div
        class="column is-2" 
        v-if="materials.length > 0">
        <div class="label-and-action">
          <label class="label mb-2">Filter by Material</label>
          <a class="icon" 
            v-if="filters.material_id"
            @click="setFilter({ field: 'material_id', value: null })">
            <i class="fas fa-times"></i>
          </a>
        </div>
        <v-select 
          :options="materials"
          item-text="name"
          item-value="id"
          :value="filters.material_id"
          @input="setFilter({ field: 'material_id', value: $event })">
        </v-select>
      </div> -->
    </div>

    <article 
      v-if="!loading && cutSheets.length == 0" 
      class="message is-info is-fullwidth">
      <div class="message-body">
        There are no cutsheets.
      </div>
    </article>

    <table
      class="table is-hoverable is-clickable sticky-header is-fullwidth has-smallish-font">
      
      <thead>
        <tr>
          <th>
            <v-checkbox 
              :value="allSelected"
              @input="toggleAllSelected($event.target.checked)"/>
          </th>
          <th
            v-for="(header, i) in headers" :key="i">
            {{ header.label }}
          </th>
        </tr>
        <tr v-if="loading">
          <th :colspan="headers.length + 2" class="py-0 px-0 is-naked">
            <v-progress class="is-fullwidth" v-model="loading"/>
          </th>
        </tr>
      </thead>

      <v-fade-transition mode="out-in">
        <tbody v-if="cutSheets.length > 0">
          <tr
            class="v-centered"
            v-for="cutSheet in cutSheets" 
            @click="viewCutSheet(cutSheet)"
            :key="cutSheet.id">
            <td @click.stop="">
              <v-checkbox 
                :value="selected.indexOf(cutSheet.id) != -1"
                @input="toggleSelected(cutSheet.id)"/>
            </td>
            <td>
              {{ cutSheet.project.project_name }}
            </td>
            <td class="text--nowrap">
              {{ cutSheet.cutsheet_no }}
            </td>
            <td>
              {{ cutSheet.item }}
            </td>
            <td>
              <span v-if="cutSheet.input_product_master">
                {{ cutSheet.input_product_master.name }}
              </span>
            </td>
            <td>
              {{ cutSheet.parts
                  .map(d => d.total_sqft)
                  .reduce((a, b) => parseFloat(a) + parseFloat(b), 0) | round(2) }}
            </td>
            <td>
              {{ cutSheet.parts.length }}
            </td>
            <td>
              {{ cutSheet.in_progress }}
            </td>
            <td>
              {{ cutSheet.completed }}
            </td>
            <td class="is-size-7">
              <div class="text--nowrap">
                {{ cutSheet.created_user.display_name }}
              </div>
              <div class="text--nowrap">
                {{ formatDatetime(parse(cutSheet.created_on)) }}
              </div>
            </td>
            <td class="text--nowrap">
              {{ formatDate(parse(cutSheet.expected_delivery_date)) }}
            </td>
            <td>
              <div class="buttons buttons-right">
                <a 
                  @click.stop="goToCutSheet(cutSheet)" 
                  class="button is-small">
                  <span class="icon">
                    <i class="fas fa-edit has-text-grey"></i>
                  </span>
                </a>
                <a 
                  @click.stop="duplicateCutSheet(cutSheet)" 
                  class="button is-small">
                  <span class="icon">
                    <i class="fas fa-copy has-text-grey"></i>
                  </span>
                </a>
                <a 
                  @click.stop="deleteId = cutSheet.id; launchConfirmDelete()"
                  class="button is-small">
                  <span class="icon">
                    <i class="fas fa-trash has-text-grey"></i>
                  </span>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </v-fade-transition>
    </table>

    <v-pagination 
      v-if="pagination.pages > 1"
      :value="pagination.page"
      @input="changePage"
      :length="pagination.pages">
    </v-pagination>

    <add-cut-sheet-modal
      v-model="addingCutSheet"
      :cut-sheet="cutSheet"
      @go="this.goToCutSheet">
    </add-cut-sheet-modal>

    <v-confirm-modal 
      v-model="confirmDelete.state"
      :title="confirmDelete.title"
      :message="confirmDelete.message"
      :type="confirmDelete.type"
      @confirm="deleteConfirmed()"
      @cancel="deleteId = null; confirmDelete.state = false">
    </v-confirm-modal>
  </div>
</template>

<script>
import VConfirmModal from '@/components/base/VConfirmModal'
import VPagination from '@/components/base/VPagination'
import VCheckbox from '@/components/base/VCheckbox'
import VProgress from '@/components/base/VProgress'
import VFadeTransition from '@/components/transitions/VFadeTransition'

import AddCutSheetModal from '@/components/cutsheet/AddCutSheetModal'
import SearchAutocomplete from '@/components/projects/SearchAutocomplete'

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

import { parseISO, format } from 'date-fns'

export default {
  components: { 
    VConfirmModal, VPagination, VProgress, VCheckbox, AddCutSheetModal, 
    VFadeTransition, SearchAutocomplete
  },
  data() {
    return {
      headers: [
        { label: 'Project' },
        { label: 'Cut Sheet #' },
        { label: 'Tag' },
        { label: 'Product' },
        { label: 'Total Sqft' },
        { label: '# of Parts' },
        { label: 'Parts in Progress'},
        { label: 'Parts Completed' },
        { label: 'Created By/ On' },
        { label: 'Expected Delivery Date' },
        { label: '' }
      ],
      addingCutSheet: false,
      cutSheet: {
        project_id: null,
        cutsheet_no: null,
        item: null,
        material_id: null,
        parts: []
      },
      parse: (d) => {
        return d ? parseISO(d) : null;
      },
      formatDate: (d) => {
        return d ? format(d, 'yyyy-MM-dd') : d
      },
      formatDatetime: (d) => {
        return d ? format(d, 'yyyy-MM-dd H:mm:ss') : d
      },
      confirmDelete: {
        state: false,
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete this cut sheet?',
        type: 'danger'
      },
      deleteId: null,
      bulk: false
    }
  },
  computed: {
    ...mapState("cutSheets", [
      "cutSheets", "loading", "pagination", "filters", 
      "selected", "allSelected"
    ]),
    ...mapGetters("cutSheets", ["cutSheetIds"])
  },
  created() {
    this.fetchCutSheets();
  },
  watch: {
    filters: {
      handler() {
        this.fetchCutSheets();
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("cutSheets", [
      "getCutSheets", "toggleAllSelected", "deleteCutSheet"
    ]),
    ...mapMutations("cutSheets", [
      "setFilter", "changePage", "toggleSelected"
    ]),
    fetchCutSheets() {
      const { pagination } = this;
      const { filters } = this;

      let parameters = {
        page: pagination.page
      }
      
      Object.keys(filters).forEach(key => {
        if (filters[key]) {
          parameters[key] = filters[key];
        }
      })

      this.getCutSheets(parameters);
    },
    duplicateCutSheet(cutSheet) {
      this.cutSheet.project_id = cutSheet.project.id;
      this.cutSheet.material_id = cutSheet.material.id;
      this.cutSheet.item = cutSheet.item;
      this.cutSheet.parts = cutSheet.parts;
      this.addingCutSheet = true;
    },
    launchConfirmDelete(bulk=false) {
      this.bulk = bulk;
      if (bulk) {
        this.confirmDelete.message = `Are you sure you want to delete the ${this.selected.length} cut sheets?`;
      } else {
        this.confirmDelete.message = 'Are you sure you want to delete this cut sheet?'
      }
      this.confirmDelete.state = true;
    },
    deleteConfirmed() {
      this.confirmDelete.state = false;

      if (this.bulk == true) {
        this.deleteSelected();
      } else {
        this.deleteCutSheet(this.deleteId).then(
          () => this.deleteId = null
        );
      }
    },
    deleteSelected() {
      this.selected.forEach(cutSheetId => {
        this.deleteCutSheet(cutSheetId);
      })
    },
    createNewCutSheet() {
      this.$router.push({
        name: 'CutSheetMaker'
      });
    },
    goToCutSheet(cutSheet) {
      this.$router.push({
        name: 'CutSheetEditor',
        params: {
          cutSheetId: cutSheet.id,
          cutSheet: cutSheet
        }
      });
    },
    viewCutSheet(cutSheet) {
      this.$router.push({
        name: 'CutSheetViewer',
        params: {
          cutSheetId: cutSheet.id,
          cutSheet: cutSheet
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';

.label-and-action {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
</style>
